import { render, staticRenderFns } from "./Log.vue?vue&type=template&id=367ed05c"
import script from "./Log.vue?vue&type=script&lang=ts"
export * from "./Log.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports